:host {
  display: block;
}

.payment-method {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--sc-spacing-x-small);
}
